import { KanbanIcon } from "@phosphor-icons/react"

import { PagePlaceholder } from "@/components/page-placeholder"

export function ProjectsPage() {
  return (
    <PagePlaceholder
      title="Projects"
      description="Your projects will show up here."
      icon={KanbanIcon}
    />
  )
}
